/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { isSignedIn } from 'Util/Auth';
import { Field } from 'Util/Query';

/** @namespace Extrafee/Query/ExtraFee/Query/ExtraFeeQuery */
export class ExtraFeeQuery {
    getQuery(quoteId, customerId) {
        const query = new Field('extraFee')
            .addFieldList(this.getExtraFeeField());

        if (isSignedIn()) {
            query.addArgument('customerId', 'String', customerId);
        } else {
            query.addArgument('quoteId', 'String', quoteId);
        }

        return query;
    }

    getExtraFeeField() {
        return [
            'isEnabled',
            'isTaxEnabled',
            'displaySuffix',
            'title',
            'description',
            'extraFee',
            'extraFeeTax'
        ];
    }
}

export default new ExtraFeeQuery();
